// extracted by mini-css-extract-plugin
module.exports = {"mathTest":"MathTest_mathTest__1v8W_","questionContainer":"MathTest_questionContainer__1wwge","buttonContainer":"MathTest_buttonContainer__1aBR9"};